export const InfiniteSpacesService = Symbol('InfiniteSpacesService');
